import { Link } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../../contexts/AuthContext";

export default function HomeSidebarGuest() {
    const { loginWithGoogle } = useAuth();

    return (
        <div className="bg-gray-50 rounded-md p-4 flex flex-col gap-3">
            <p className="text-sm text-gray-600">
                Sign in to track your progress and build your schedule
            </p>
            <GoogleLogin
                onSuccess={async (credentialResponse) => {
                    if (!credentialResponse.credential) return;
                    try {
                        await loginWithGoogle(credentialResponse.credential);
                    } catch (err) {
                        console.error('Google sign-in error:', err);
                    }
                }}
                onError={() => console.error('Google sign-in failed')}
                useOneTap={false}
                text="continue_with"
                shape="rectangular"
                size="large"
                width="280"
            />
            <p className="text-xs text-gray-400 leading-relaxed">
                By continuing, you agree to our{' '}
                <Link to="/terms" className="underline hover:text-gray-600">Terms of Service</Link>
                {' '}and{' '}
                <Link to="/privacy" className="underline hover:text-gray-600">Privacy Policy</Link>.
            </p>
            <p className="text-xs text-gray-400 leading-relaxed">
                CourseMap is for planning only — always verify with official sources.
            </p>
            <p className="text-xs text-gray-400 leading-relaxed">
                Found an issue?{' '}
                <a href="https://forms.gle/QjjAxdeXQms7rNCF8" target="_blank" rel="noopener noreferrer" className="underline text-gray-400 hover:text-gray-600">Report here</a>
            </p>
        </div>
    );
}
